import { render, staticRenderFns } from "./EvidencesTable.vue?vue&type=template&id=2f5230e2&"
import script from "./EvidencesTable.vue?vue&type=script&lang=ts&"
export * from "./EvidencesTable.vue?vue&type=script&lang=ts&"
import style0 from "./EvidencesTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports